import { isAuth0Desktop401RecoveryEnabled } from '@/app-shell/flags/auth0-desktop-401-recovery';
import { AuthProvider } from '@/utils/auth/persistedAuthProvider';
import { isAuth401RecoveryReady } from '@heidi/auth/predicates';

/**
 * Shared by the request-path context resolver and the 401-retry handler so
 * their eligibility rules can't drift. A provider is recovery-eligible when
 * it's in the static allowlist AND, for AUTH0_DESKTOP specifically, the
 * desktop rollout flag is on — every other allowlisted provider (AUTH0 web)
 * has no flag gate.
 */
export function isRecoveryEligible(
  provider: AuthProvider | null | undefined,
  tauri: boolean
): boolean {
  if (!isAuth401RecoveryReady(provider, tauri)) return false;
  if (provider === AuthProvider.AUTH0_DESKTOP) return isAuth0Desktop401RecoveryEnabled();
  return true;
}
